import React, {FC} from 'react';

import {Box, DialogContent, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog, StyledBottomSheet} from './styles';

export interface BasketDeliveryDetailsMakroFleetModal {
  open: boolean;
  sellerName: string;
  deliveryBy: string;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const BasketDeliveryDetailsMakroFleetModal: FC<BasketDeliveryDetailsMakroFleetModal> = ({
  open,
  onClose,
  sellerName,
  deliveryBy,
  isReactNativeWebView
}) => {
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer className="MakroFleetDeliveryModal" open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('sellerDelivery.makroFleet.deliveryHandledByMakro')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Box>
            <Typography fontSize={14} fontWeight={400}>
              <Trans
                i18nKey={'sellerDelivery.makroFleet.productIsSoldByAndDeliveredByMKP'}
                values={{shopName: sellerName}}
              />
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={14} fontWeight={400}>
              {t('sellerDelivery.makroFleet.chooseDeliveryTimeForMakroFleet', {
                timeFrame: deliveryBy
              })}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={12} fontWeight={400} color="grey.400">
              {t('sellerDelivery.makroFleet.makroFleetRemark')}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={14} fontWeight={400}>
              {t('sellerDelivery.makroFleet.proPointsCantBeUsed')}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

BasketDeliveryDetailsMakroFleetModal.displayName = 'BasketDeliveryDetailsMakroFleetModal';
